const shortDate = new Intl.DateTimeFormat([], { month: 'short', day: 'numeric' }).format

export function timeAgo(input, now = Date.now()) {
  if (!input) return ''
  const then = new Date(input).getTime()
  if (Number.isNaN(then)) return ''
  const diff = now - then
  const min = 60 * 1000
  const hour = 60 * min
  const day = 24 * hour
  if (diff < min) return 'just now'
  if (diff < hour) return `${Math.floor(diff / min)}m ago`
  if (diff < day) return `${Math.floor(diff / hour)}h ago`
  if (diff < 7 * day) return `${Math.floor(diff / day)}d ago`
  return shortDate(new Date(then))
}

const relativeFormat = new Intl.RelativeTimeFormat('en-US', { numeric: 'always' })

const LONG_UNITS = [
  ['year', 365 * 24 * 60 * 60 * 1000],
  ['month', 30 * 24 * 60 * 60 * 1000],
  ['week', 7 * 24 * 60 * 60 * 1000],
  ['day', 24 * 60 * 60 * 1000]
]

export function timeSinceLong(input, now = Date.now()) {
  if (!input) return ''
  const then = new Date(input).getTime()
  if (Number.isNaN(then)) return ''
  const diff = now - then
  const unit = LONG_UNITS.find(([, ms]) => diff >= ms)
  if (!unit) return 'today'
  return relativeFormat.format(-Math.floor(diff / unit[1]), unit[0])
}
